import React from 'react';
import * as CountryFlag from 'country-flag-icons/react/3x2';
import { cn } from '../utils/utils';

const FlagComponent = ({ code, className }) => {
  const FlagComponent = CountryFlag[code];

  if (!FlagComponent) return null;

  return <FlagComponent className={cn('h-4', className)} />;
};

export default FlagComponent;
